import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthorizationService } from '../../core/services/authorization.service';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
resetForm: FormGroup;
submitted = null;
email: any;
token: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
     private formBuilder: FormBuilder,
     private resetService: AuthorizationService,
     private toastrService: ToastrService) { 
    this.createForm();
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('resetCode')
  }

  ngOnDestroy() {
  }

  private createForm() {
    this.resetForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    }, {
      validator: this.passwordValidator
    });
  }

  onSubmit() {
    this.submitted = false;
    if(this.resetForm.invalid) {
      return
    }
      this.submitted = true;
      if(this.resetForm.valid) {
        const obj = {
          email: this.route.snapshot.queryParamMap.get('email'),
          password: this.resetForm.value.password,
          resetCode : this.token
        }

        this.resetService.resetPassword(obj)
        .pipe(first())
        .takeUntil(componentDestroyed(this))
        .subscribe(res => {
          this.toastrService.success('password has been changed');
          this.router.navigate(['/login']);
        });
        this.clearForm();
      }
  }


  get f() { return this.resetForm.controls }


  passwordValidator(form: FormGroup) {
    const condition = form.get('password').value !== form.get('confirmPassword').value;
    return condition ? { passwordsDoNotMatch: true } : null;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.resetForm.controls[controlName];
    if (!control) {
      return false;
    }
    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  clearForm() {
    this.submitted = false;
    this.resetForm.reset();
      Object.keys(this.resetForm.controls).forEach(key => {
        this.resetForm.get(key).setErrors(null) ;
      });
  }
}
